import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaGithub, FaTwitter, FaInstagram, FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="bg-dark pt-32 pb-10 text-white font-sans relative overflow-hidden">
            {/* Background Texture */}
            <div className="absolute inset-0 z-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16">
                    {/* Brand Info */}
                    <div className="space-y-6 col-span-2 lg:col-span-1">
                        <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            className="text-2xl font-black text-white tracking-widest"
                        >
                            TECH<span className="text-secondary">INOVANT</span>
                        </motion.div>
                        <p className="text-sm leading-relaxed text-white">
                            Global leaders in digital engineering and consulting. We help clients navigate their digital transformation journey.
                        </p>
                        <div className="flex space-x-4 pt-4">
                            {[FaLinkedin, FaGithub, FaTwitter, FaInstagram].map((Icon, i) => (
                                <motion.a
                                    key={i}
                                    href="#"
                                    whileHover={{ y: -5, color: '#0EA5E9' }}
                                    className="bg-white/10 p-3 rounded-full hover:bg-white/20 transition-colors text-white"
                                >
                                    <Icon className="text-lg" />
                                </motion.a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="text-left">
                        <h4 className="text-white font-bold mb-6 text-lg relative inline-block">
                            Company
                            <span className="absolute -bottom-2 left-0 w-1/2 h-1 bg-secondary rounded-full"></span>
                        </h4>
                        <ul className="space-y-3 text-sm">
                            {['About Us', 'Services', 'Case Studies', 'Careers', 'Contact'].map((item) => (
                                <li key={item}>
                                    <a href="#" className="hover:text-secondary transition-colors text-white block">
                                        {item}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Services Links */}
                    <div className="text-left">
                        <h4 className="text-white font-bold mb-6 text-lg relative inline-block">
                            Capabilities
                            <span className="absolute -bottom-2 left-0 w-1/2 h-1 bg-secondary rounded-full"></span>
                        </h4>
                        <ul className="space-y-3 text-sm">
                            {['Cloud Computing', 'AI & Automation', 'Cybersecurity', 'Data Analytics', 'IoT Solutions'].map((item) => (
                                <li key={item}>
                                    <a href="#" className="hover:text-secondary transition-colors text-white block">
                                        {item}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className="text-left col-span-2 lg:col-span-1">
                        <h4 className="text-white font-bold mb-6 text-lg relative inline-block">
                            Get in Touch
                            <span className="absolute -bottom-2 left-0 w-1/2 h-1 bg-secondary rounded-full"></span>
                        </h4>
                        <ul className="space-y-4 text-sm mt-4 text-white">
                            <li className="flex items-start">
                                <FaMapMarkerAlt className="mt-1 mr-3 text-secondary shrink-0" />
                                <span>Mahesh Nagar Road No-2<br />Patna - 800024</span>
                            </li>
                            <li className="flex items-center">
                                <FaEnvelope className="mr-3 text-secondary shrink-0" />
                                <a href="mailto:info@techinovant.com" className="hover:text-white transition">info@techinovant.com</a>
                            </li>
                            <li className="flex items-center">
                                <FaPhone className="mr-3 text-secondary shrink-0" />
                                <a href="tel:+919296381495" className="hover:text-white transition">+91 92963 81495</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-white">
                    <p>&copy; {new Date().getFullYear()} Tech Inovant Inc. All rights reserved.</p>
                    <div className="space-x-6 mt-4 md:mt-0">
                        <a href="#" className="hover:text-white transition">Privacy Policy</a>
                        <a href="#" className="hover:text-white transition">Terms of Service</a>
                        <a href="#" className="hover:text-white transition">Sitemap</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
